import React from "react";

function Breadcrumbs() {
    return (
        <div>
            <div className="breadcrumbs_section">
                <div className="background_area">

                </div>
            </div>
        </div>
    );
}

export default Breadcrumbs;
